import { MapPin, Mail } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';

const Contact = () => {
  const { t } = useLanguage();

  const contactInfo = [
    {
      icon: Mail,
      title: t('contact.email'),
      details: [
        "Všeobecné informácie: office-loz@iacgroup.com",
        "HR: hr-loz@iacgroup.com",
        "Logistika: logistika-loz@iacgroup.com"
      ]
    },
    {
      icon: MapPin,
      title: t('contact.address'),
      details: [
        "IAC Group (Slovakia) s.r.o.",
        "Automobilový priemyselný park Lozorno 1006",
        "900 31 Lozorno",
        "Slovakia"
      ]
    }
  ];

  return (
    <section id="contact" className="py-20 bg-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6">
            {t('contact.title')}
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Contact Information */}
          <div className="space-y-8">
            {contactInfo.map((info, index) => (
              <div key={index} className="bg-card p-6 rounded-lg shadow-sm">
                <div className="flex items-start gap-4">
                  <div className="inline-flex items-center justify-center w-10 h-10 bg-primary/10 rounded-lg flex-shrink-0">
                    <info.icon className="h-5 w-5 text-primary" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-foreground text-lg mb-3">{info.title}</h3>
                    <div className="space-y-2">
                      {info.details.map((detail, detailIndex) => (
                        <p key={detailIndex} className="text-muted-foreground">
                          {detail}
                        </p>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Google Maps */}
          <div className="h-full min-h-[400px] rounded-lg overflow-hidden">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2651.533918881033!2d17.024996312031185!3d48.35026333621063!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x476cec83ced98275%3A0xb76cc352d78610f5!2sIAC%20Group%20(Slovakia)%20s.r.o.%20Automobilov%C3%BD%20priemyseln%C3%BD%20park%20Lozorno%201006!5e0!3m2!1ssk!2ssk!4v1757354183381!5m2!1ssk!2ssk"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="IAC Group Slovakia Location"
            ></iframe>
          </div>
        </div>
      </div>
      
    </section>
  );
};

export default Contact;